import React from 'react';
import { useActivitySession } from '../../hooks/useActivitySession';

/**
 * Renders nothing; exists solely to run the activity heartbeat inside the
 * AuthProvider subtree (audit finding H5 — `userSessions` had no writer).
 *
 * Mounted once in App.tsx. Do not mount a second instance: the hook keys its
 * interval off nothing but mount state, so duplicates would double the ping
 * rate without recording any additional time.
 */
export const ActivityTracker: React.FC = () => {
  useActivitySession();
  return null;
};

ActivityTracker.displayName = 'ActivityTracker';
